export default "__VITE_ASSET__a84a9e7f__"